
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';
import { ChatEscalationInterface, TicketEscalationInterface } from '@/services/QC-V2/escalation/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class EscalationDetails extends Vue {
  @Prop() private escalation!: ChatEscalationInterface | TicketEscalationInterface;

  @Prop() private profilesMap!: ProfileMapInterface;

  private loading: boolean = false;

  private collapsed: boolean = false;

  private escalationPriorityMap: { [key: string]: string } = {
    low: 'LOW',
    normal: 'NORMAL',
    medium: 'MEDIUM',
    high: 'HIGH',
    critical: 'CRITICAL',
  };

  private escalationStatusMap: { [key: string]: string } = {
    'open': 'OPEN',
    'reviewed': 'REVIEWED',
    'in-progress': 'IN PROGRESS',
  };
}
